import React from "react";
import { Link } from "react-router-dom";

const buildModulePath = (moduleName, moduleUrl) => {
  if (moduleUrl) {
    return moduleUrl.startsWith("/") ? moduleUrl : `/${moduleUrl}`;
  }
  if (!moduleName) return "/";
  if (moduleName.includes("/")) {
    return moduleName.startsWith("/") ? moduleName : `/${moduleName}`;
  }
  return `/bbs/${moduleName}`;
};

const formatRelativeDays = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number") return `${value}일 전`;
  if (value instanceof Date) {
    const diff = Math.max(0, Math.floor((Date.now() - value.getTime()) / (1000 * 60 * 60 * 24)));
    return `${diff}일 전`;
  }
  return "";
};

const resolveItemTime = (item) => {
  if (item.time) return formatRelativeDays(item.time);
  if (item.created_at) return formatRelativeDays(new Date(item.created_at));
  return "";
};

const BbsCard = ({ title, module_name, module_url, items }) => {
  const listPath = buildModulePath(module_name, module_url);
  return (
    <div className="glass-card h-full p-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-white">{title}</h2>
          {/* <p className="text-xs text-ink-200">최근 게시글 5개를 빠르게 확인하세요.</p> */}
        </div>
        <Link to={listPath} className="btn-ghost">
          전체 보기
        </Link>
      </div>
      <div className="mt-4 space-y-3">
        {items.map((item, index) => (
          <Link
            key={index}
            to={item.url}
            className="flex flex-col gap-2 rounded-xl border border-white/5 bg-white/5 px-4 py-3 text-sm text-ink-200 transition hover:border-brand-400/40 hover:bg-white/10"
          >
            <div className="flex items-center">
              <div className="flex flex-wrap items-center gap-2">
                <span className="chip">{item.category}</span>
                <span className="text-white">{item.title}</span>
                <span className="text-xs text-ink-200">[{item.count}]</span>
              </div>

              <span className="ml-auto">{resolveItemTime(item)}</span>
            </div>
            {/* <div className="flex items-center justify-between text-xs text-ink-200">
              {item.count !== undefined && <span className="pill">댓글 {item.count}</span>}
            </div> */}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BbsCard;
